import React from 'react';
import { Modal, Table, Tooltip, Button, Tag, message } from 'antd';
import ConfigService from '../../../services/config.service';
import { getExecutive, getRole, getChild } from '../../../utils/utils';
import NewUser from './new-user';
import './users.scss';

class Users extends React.Component {

  state = {
    users: [],
    visible: false,
    loading: false,
    userToEdit: null,
    editUser: false
  }

  componentDidMount() {
    this.getUsers();
  }

  getUsers = () => {
    this.setState({ loading: true });
    ConfigService.getUsers()
      .then(users => {
        this.setState({ users });
        this.setState({ loading: false });
      }, error => {
        console.log(error);
      }).catch(err => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  setNewUser = (newUser) => {
    const { users } = this.state;
    users.push(newUser);
    this.setState({ users, visible: false });
    message.success("Usuario creado");
  }

  showNewUserModal = () => {
    this.setState({ visible: true });
  }

  handleCancel = () => {
    this.setState({ visible: false, editUser: false, userToEdit: null });
  }

  updatedUser = () => {
    message.success("Usuario editado");
    this.setState({
      visible: false,
      editUser: false
    })
  }

  rowClicked = (row) => {
    this.setState({
      userToEdit: row,
      visible: true,
      editUser: true
    })
  }

  render() {
    return (
      <div>
        <div className="usr-button-panel">
          <h2 style={{ fontWeight: 'lighter' }}>Usuarios registrados</h2>
          <Tooltip placement="left" title='Agregar usuario'>
            <Button className="action-button" onClick={this.showNewUserModal} type="primary" shape="circle" icon="plus" />
          </Tooltip>
        </div>

        <Table
          loading={this.state.loading}
          dataSource={this.state.users}
          rowKey="id"
          columns={this.columns()}
          style={{ maxWidth: '100%' }}
          pagination={{ pageSize: 8 }}
          onRow={(record) => ({ onClick: () => { this.rowClicked(record) } })} />

        <Modal
          title="Crear usuario"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="Crear"
          width="65vw"
          centered
          footer={null}
        >
          <NewUser
            onCreated={this.setNewUser}
            user={this.state.userToEdit}
            edit={this.state.editUser}
            onEdited={this.updatedUser} />
        </Modal>
      </div>
    )
  }

  columns = () => {
    return [
      {
        title: 'Usuario',
        dataIndex: 'username',
      },
      {
        title: 'Rol',
        dataIndex: 'role',
        render: (role) => getRole(role)
      },
      {
        title: 'Institución',
        dataIndex: 'organism',
        render: (organism) => getExecutive(organism).name || getChild(organism).name
      },
      {
        title: 'Estado',
        dataIndex: 'status',
        render: (status) => {
          if (status === 1) {
            return <Tag color="green">Activo</Tag>
          }
          return <Tag color="red">Inactivo</Tag>
        }
      }
    ]
  }

}

export default Users;